import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import createAssessmentTransferRouter from "./AssessmentTransferRouter";

export default store => ({
  path: "assessment-transfer/*",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "Administrator/routes/SchoolSetup/routes/AssessmentTransferV2/components"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "Administrator/routes/SchoolSetup/routes/AssessmentTransferV2/modules/AssessmentTransferV2Module"
      ),
      import(/* webpackChunkName: "grade-levels" */ "./components"),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "AssessmentTransfer/modules/AssessmentTransferModule"
      ),
    ]).then(([v2Components, v2Module, v1Components, v1Module]) => {
      injectReducer(store, {
        key: v2Module.NAME,
        reducer: v2Module.default,
      });
      injectReducer(store, {
        key: v1Module.NAME,
        reducer: v1Module.default,
      });
      return createAssessmentTransferRouter(
        v1Components.default,
        v2Components.default
      );
    })
  ),
  childRoutes: [],
});
